// Copyright (c) 2016 Deere & Company

import SelectedDealers, {getDefaultState} from '../state/selected-dealers';
import actions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const selectAllDealers = (state, action) => {

    const toggleSelectedDealersState = state.length > 0 ? [] : action.dealers;

    return SelectedDealers.update(state, {
        $set: toggleSelectedDealersState
    });

};

const selectDealer = (state, action) =>
    SelectedDealers.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

const selectAllDealersOnLoad = (state, action) =>
    SelectedDealers.update(state, {
        $set: action.dealers
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.SELECT_ALL_CREDIT_MEMO_DEALERS]: selectAllDealers,
        [actions.SELECT_ALL_CREDIT_MEMO_DEALERS_ON_LOAD]: selectAllDealersOnLoad,
        [actions.SELECT_CREDIT_MEMO_DEALER]: selectDealer
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/reports/credit-memo/reducers/selected-dealers.js